<template>
  <div class="booking-card-outer-container">
    <div
      id="self-inclusive"
      class="tdesk-container"
      :data-testid="yesText"
      @click="includeSelfInBooking(true)"
    >
      <div class="booking-card-inner-container">
        <i class="fas fa-user-plus" />
        <p>{{ yesText }}</p>
        <i class="fas fa-chevron-circle-right" />
      </div>
    </div>
    <div
      id="self-exclusive"
      class="tdesk-container"
      @click="includeSelfInBooking(false)"
    >
      <div class="booking-card-inner-container">
        <i class="fas fa-user-minus" />
        <p>{{ noText }}</p>
        <i class="fas fa-chevron-circle-right" />
      </div>
    </div>
  </div>
</template>

<script>
  import fireGaEvent from './fire_ga_event';

  export default {
    props: {
      bookingType: {
        required: true,
        type: String,
      },
    },
    computed: {
      yesText() {
        if (this.bookingType === 'individual') {
          return "I'm booking for myself";
        }
        return "I'm part of the group";
      },
      noText() {
        if (this.bookingType === 'individual') {
          return "I'm booking on behalf of somebody";
        }
        return "I'm booking on behalf of the group";
      },
    },
    methods: {
      includeSelfInBooking(decision) {
        fireGaEvent( 'ssbc_v2_step2_include_self', {'include_self': decision});
        this.$emit('include-self-in-booking', decision);
        if (this.bookingType === 'individual') {
          return this.$emit('reserve-places');
        }
        this.$emit('proceed');
      },
    },
  };
</script>
